import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetIncidentTableRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}IncidentTracker/GetIncidentTable`
});

export const GetDropdownsRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}IncidentTracker/GetDropdowns`
});

export const GetAllDropdownsRequest = (incidentId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}IncidentTracker/GetAllDropdowns`,
	params: { incidentId }
});

export const GetProjectsDropdownRequest = (siteId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}IncidentTracker/GetProjectsDropdown`,
	params: { siteId }
});

export const GetSowDropdownRequest = (siteId, project) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}IncidentTracker/GetSowDropdown`,
	params: { siteId, project }
});

export const GetLayersDropdownRequest = (techs) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}IncidentTracker/GetLayersDropdown`,
	data: techs
});

export const GetTypeDropdownRequest = (genericType) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}IncidentTracker/GetTypeDropdown`,
	params: { genericType }
});

export const GetDetailedTypeDropdownRequest = (type) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}IncidentTracker/GetDetailedTypeDropdown`,
	params: { type }
});

export const GetIncidentBaseRequest = (siteId, project, sow) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}IncidentTracker/GetIncidentBase`,
	params: { siteId, project, sow }
});

export const CreateIncidentRequest = (incidentForm) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}IncidentTracker/CreateIncident`,
	data: incidentForm
});

export const EditIncidentRequest = (incidentForm) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}IncidentTracker/EditIncident`,
	data: incidentForm
});

export const GetIncidentRequest = (incidentId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}IncidentTracker/GetIncident`,
	params: { incidentId }
});

export const ExportIncidentsRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}IncidentTracker/ExportIncidents`,
});
